define('bootstrapping/knockoutBindingTask',[
    'bootstrapping/knockoutBindings/areaBinding',
    'bootstrapping/knockoutBindings/backgroundBinding',
    'bootstrapping/knockoutBindings/circleProgressBinding',
    'bootstrapping/knockoutBindings/contextBinding',
    'bootstrapping/knockoutBindings/elementsWrapBinding',
    'bootstrapping/knockoutBindings/focusHandlerBinding',
    'bootstrapping/knockoutBindings/scrollIntoViewBinding',
    'viewmodels/questions/dragAndDrop/bindingHandlers/dropspotBindingHandler',
    'viewmodels/questions/fillInTheBlank/bindingHandlers/fillInTheBlankAnswersBinding',
    'viewmodels/questions/textMatching/bindingHandlers/draggableBindingHandler',
    'viewmodels/questions/textMatching/bindingHandlers/droppableBindingHandler',
    'viewmodels/questions/textMatching/bindingHandlers/overlayBindingHandler',
    'viewmodels/questions/textMatching/bindingHandlers/syncHeightBindingHandler',
    'viewmodels/questions/textMatching/bindingHandlers/syncHeightScopeBindingHandler',
    'widgets/imagePreview/bindingHandlers/fadeBindingHandler',
    'widgets/imagePreview/bindingHandlers/imageLoaderBindingHandler'
], function () {

    return {
        execute: function () { }
    };

});
